import React from 'react';
import { TrendingUp, Building2, Truck, Drill, Check, Rocket, Calculator } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  'Stock Market Investment': TrendingUp,
  'Real Estate Investment': Building2,
  'Technology Startups': Rocket,
  'Tax Strategy Planning': Calculator,
  'Heavy Equipment Lease': Truck,
  'Oil & Gas Exploration': Drill
};

const Services = () => {
  return (
    <section id="services" className="section-dark">
      <div className="container-standard">
        <div className="section-header">
          <h2 className="section-title">Investment Solutions</h2>
          <p className="section-subtitle">
            Diversified investment opportunities tailored to your financial goals and risk profile
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => {
            const Icon = iconMap[service.title];
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  <Icon size={32} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="service-feature-item">
                      <Check size={16} className="feature-check" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
